import Project1 from "./6minded.png";
import Project2 from "./Alliance-Nepal.png";
import Project3 from "./Company-Portfolio.png";
import Project4 from "./Date-Me.png";
import Project5 from "./Digital-Marketing.png";
import Project6 from "./Dreamers-Mart.png";
import Project7 from "./First-Help.png";
import Project8 from "./Geeta-Aviation.png";
import Project9 from "./Kathmandu-University(BSC.Nursing).png";
import Project11 from "./Montesswori.png";
import Project10 from "./Parichit-Photography.png";
import Project12 from "./Pashmina-Dashboard.png";
import Project13 from "./Pro-Med.png";
import Project14 from "./Restro-WebApp.png";
import Project15 from "./Safe-Drive.png";
import Project16 from "./ALFboss.png";
import Project17 from "./Aspire.png";
import Project18 from "./blueprint.png";
import Project19 from "./Dynamic-Energy-Solution.png";
import Project20 from "./gopaylater.png";
import Project21 from "./gstarnepal.png";
import Project22 from "./Hulas-Steel.png";
import Project23 from "./JapNep.png";
import Project24 from "./Keiv-Connect.png";
import Project25 from "./Kit-Ar.png";
import Project26 from "./Level-Up.png";
import Project27 from "./Level-Up-Dark.png";
import Project28 from "./lifefood.png";
import Project29 from "./Nepcoms.png";
import Project30 from "./Orka-Socials.png";
import Project31 from "./Personal-Portfolio.png";
import Project32 from "./Smart-Bhancha.png";
import Project33 from "./Youtuber-Site.png";
import Project34 from "./Zoom-Beauty-Academy.png";

const Images = {
  Project1,
  Project2,
  Project3,
  Project4,
  Project5,
  Project6,
  Project7,
  Project8,
  Project9,
  Project10,
  Project11,
  Project12,
  Project13,
  Project14,
  Project15,
  Project16,
  Project17,
  Project18,
  Project19,
  Project20,
  Project21,
  Project22,
  Project23,
  Project24,
  Project25,
  Project26,
  Project27,
  Project28,
  Project29,
  Project30,
  Project31,
  Project32,
  Project33,
  Project34,
};
export default Images;
